export default {
  languageConfiguration: 'Configuración del idioma',
  defaultNavigationLanguage: 'Idioma de navegación por defecto',
  defaultNavigationLanguageDescription: 'Esto configurará el idioma por defecto de navegación de la plataforma.',
  defaultMailingLanguage: 'Idioma de notificaciones',
  defaultMailingLanguageDescription: 'Esto configura el idioma con el que recibes las notificaciones por correo electrónico.',
  save: 'Guardar cambios',
  languageRequiredError: 'Debes elegir un idioma'
}

export const en = {
  languageConfiguration: 'Language settings',
  defaultNavigationLanguage: 'Default navigation language',
  defaultNavigationLanguageDescription: 'This will set the default navigation language of the platform.',
  defaultMailingLanguage: 'Notification language',
  defaultMailingLanguageDescription: 'This will set the language in which you receive email notifications.',
  save: 'Save changes',
  languageRequiredError: 'Debes elegir un idioma'
}

export const ca = {
  languageConfiguration: 'Configuració d\'idioma',
  defaultNavigationLanguage: 'Idioma de navegació per defecte',
  defaultNavigationLanguageDescription: 'Això configurarà l\'idioma per defecte de navegació de la plataforma.',
  defaultMailingLanguage: 'Idioma de notificacions',
  defaultMailingLanguageDescription: 'Això configura l\'idioma amb el qual reps les notificacions per correu electrònic.',
  save: 'Desar els canvis',
  languageRequiredError: 'Debes elegir un idioma'
}
